import React from "react";

const SCREEN_MOBILE = 664;
const SCREEN_TABLET = 1024;

export const MOBILE = 'mobile'
export const TABLET = 'tablet'
export const DESKTOP = 'desktop'

const useDeviceType = () => {

    const getDeviceType = () => {
        const outerWidth = window.outerWidth;
        const innerWidth = window.innerWidth;
      
        if (outerWidth <= SCREEN_MOBILE || innerWidth <= SCREEN_MOBILE) {
            return MOBILE;
        } else if (outerWidth <= SCREEN_TABLET || innerWidth <= SCREEN_TABLET) {
            return TABLET;
        } else {
            return DESKTOP;
        }
    };

    const [deviceType, setDeviceType] = React.useState(getDeviceType());

    const handleResize = () => {
        setDeviceType(getDeviceType());
    };

    React.useEffect(() => {

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return deviceType;
}

export default useDeviceType;